<template>
  <div id="table-custom">
    <v-data-table
      :height="height"
      fixed-header
      :headers="headers"
      :items="items.data"
      hide-default-footer
      disable-pagination
      class="datatable"
      :loading="loading"
      :options.sync="options"
      multi-sort
    >
      <template v-slot:top>
        <slot name="customfilter" />
      </template>
      <!-- <template v-if="!isMobileDevice()" v-slot:header="{ props: { headers } }">
        <thead>
          <tr>
            <th
              v-for="(item,index) in headers"
              v-bind:key="index"
              class="p-2 text-center"
              :class="{ 'first' : index == 0, 'last': index == headers.length-1 }"
              :style="item.value === 'number' ? 'padding: 0 0 0 10px !important; width: 10px !important;' : item.style"
            >{{ item.text }}</th>
          </tr>
        </thead>
      </template> -->
      <!-- <template v-slot:[`item.number`]="data"> -->
        <!-- <td class="text-center">{{ data }}</td> -->
        <!-- <td class="text-center">{{ data.index + 1 }}</td> -->
      <!-- </template> -->
      <template v-for="(header, index) in headers" :style="header.style" v-slot:[`item.${header.value}`]="data">
        <!-- handling non mobile device table content -->
        <slot :name="header.value" v-bind="data" v-if="header.value === 'number' && !isMobileDevice()"> <span :key="header.value">{{ data.index + 1 + (page - 1) * items.size }}</span></slot>
        <slot :name="header.value" v-if="header.value !== 'number' && !isMobileDevice()" :style="header.style" v-bind="data">
          <template v-if="!isNested(header.value)">{{ data.item[header.value] }}</template>
          <template v-if="isNested(header.value)">{{ getKeys(data.item, header.value) || '-' }}</template>
          <!-- <template>{{ data.item[header.value] || getKeys(data.item, header.value) }}</template> -->
        </slot>
        <!-- handling mobile device table content -->
        <slot
          :name="header.value"
          v-if="isMobileDevice()"
          v-bind="data">
          <template v-if="!isNested(header.value)">
            <span v-if="header.value === 'number'" v-bind:key="index"><b>{{ header.text }}</b> {{ data.index + 1 + (page - 1) * items.size }}</span>
            <span v-else v-bind:key="index">
              <b>{{ header.text }}</b> : {{ data.item[header.value] }}
            </span>
          </template>
          <template v-else-if="isNested(header.value)"><b v-bind:key="index">{{ header.text }}</b> : {{ getKeys(data.item, header.value) || '-' }}</template>
        </slot>
      </template>

      <template
        v-if="appendRow"
        v-slot:[`body.append`]="{ headers }"
      >
        <slot name="appendRow" v-bind="headers">
          <template></template>
        </slot>
        <slot name="appendRowAction" v-bind="headers">
          <template></template>
        </slot>
      </template>

    </v-data-table>
    <v-row v-if="items.totalElements > 0 && showPagination == true">
      <v-col class="mt-5" cols="8">
        Menampilkan
        <v-select
          v-model="size"
          :items="optionsSize"
          dense
          solo
          flat
          class="ml-1 mr-1 size-select"
          @change="onChangeSize"
        ></v-select>
        data dari <b>{{ items.totalElements }}</b>
      </v-col>
      <v-spacer></v-spacer>
      <v-col class="text-right mt-5">
        <v-pagination v-model="page" :length="items.total" :total-visible="5" @input="onChangePage"></v-pagination>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: 'TableCustom',
  props: {
    headers: {
      type: Array,
      required: true
    },
    items: {
      type: Object,
      required: true
    },
    loading: {
      type: Boolean,
      required: false
    },
    appendRow: {
      type: Boolean,
      required: false,
      default: false
    },
    defaultSize: {
      type: Number,
      required: false
    },
    showPagination: {
      type: Boolean,
      required: false,
      default: true
    },
    height: {
      type: String,
      required: false,
      default: 'max-content'
    },
    // reRender used for resetting page to 1 and size to default when table's headers & items changed
    reRender: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data () {
    return {
      page: 1,
      pageCount: 10,
      size: 20,
      optionsSize: [5, 10, 20, 30, 50],
      options: {}
    }
  },
  created () {
    if (this.defaultSize) {
      this.size = this.defaultSize
    }
  },
  watch: {
    reRender: function (val) {
      if (val === true) {
        this.page = 1
        this.size = this.defaultSize ? this.defaultSize : 20
      }
    },
    items: function (val) {
      this.page = val.page
      this.size = val.size
    },
    options: {
      handler () {
        this.$emit('sortOptions', this.options)
      },
      deep: true
    }
  },
  methods: {
    async onChangePage () {
      // check if table query is available
      // const tableQuery = JSON.parse(localStorage.getItem('tableQuery'))
      // tableQuery.page = this.page - 1
      // localStorage.setItem('tableQuery', JSON.stringify(tableQuery))

      // triggered when change page and size
      this.$emit('onChangePage', this.page - 1, this.size)
    },
    async onChangeSize () {
      // check if table query is available
      // const tableQuery = JSON.parse(localStorage.getItem('tableQuery'))
      // tableQuery.size = this.size
      // localStorage.setItem('tableQuery', JSON.stringify(tableQuery))

      // return page to 0 (first page) when size changed
      // this.page = 1
      this.$emit('onChangePage', this.page - 1, this.size)
    },
    // use for get nested object key
    getKeys (data, keyName) {
      return keyName.split('.').reduce((a, b) => {
        // if property not exist stop
        if (!a || !b) return '-'
        return a[b]
      }, data)
    },
    // method for check is object key is nested or not
    isNested (item) {
      if (item.includes('.')) {
        return true
      }
      return false
    }
  }
}
</script>
